import fp from "lodash/fp"
import queryString from "query-string"

import { passengerCountersSelector } from "../selectors/reliantSelectors"
import { makeQuery } from "common/services/query/queries"
import { getJourney } from "../../journey/reducer"
import { getBasePrice } from "../../prices/reducer"
import { getBookingToken, getActiveStep, getMultistep, getRefFlags } from "../../states/reducer"
import urlPrefixSelector from "common/services/url/prefixSelector"
import { createInsuranceQuery } from "booking/services/reservation/insuranceUtil"
import { isInsuranceEnabledInReservationSelector } from "../selectors/reservationSelectors"
import { setSerializedRefFlags } from "../../tracking/helpers/refFlags"
import { getInsurancePassengers } from "booking/services/additionalServices/services/insurance/reducer"
import { passengersValuesSelector } from "../selectors/passengersSelectors"

const updateUrl = () => (dispatch, getState) => {
  const state = getState()
  const passengers = fp.get("form.reservation.passengers")(state)
  const decoratedPassengers = passengersValuesSelector(state)

  const handBags = decoratedPassengers.map(pap => pap.baggage.handBag).join("-")
  const holdBags = decoratedPassengers.map(pap => pap.baggage.holdBag).join("-")

  const passengersCounters = passengerCountersSelector(state)
  const insuranceEnabled = isInsuranceEnabledInReservationSelector(state)
  const insurancePassengers = getInsurancePassengers(state)
  const multistep = getMultistep(state)
  const currentUrl = window.location
  const queryParams = queryString.parse(currentUrl.search)

  // params pickBy
  const params = fp.pipe(
    setSerializedRefFlags("ref", getRefFlags(state)),
    fp.pickBy(fp.identity),
  )({
    ...fp.omit(["promocode", "bags", "searchBags"], queryParams),
    passengers:
      passengersCounters.infant || passengersCounters.child || passengersCounters.teen
        ? [
            passengersCounters.adult,
            passengersCounters.teen || 0,
            passengersCounters.child || 0,
            passengersCounters.infant || 0,
          ].join("-")
        : passengersCounters.total,
    price: getBasePrice(state).amount,
    flightsId: getJourney(state).getId(), // Deprecated, for compatibility with old booking
    handBags,
    holdBags,
    insurance: createInsuranceQuery(passengers, insurancePassengers, insuranceEnabled),
    token: getBookingToken(state),
    "node_override_api*Url": state.query["node_override_api*Url"],
    node_override_apiGraphQLUrl: state.query.node_override_apiGraphQLUrl,
    node_override_ancillaries: state.query.node_override_ancillaries,
    activeStep: multistep ? `${getActiveStep(state)}` : null,
  })

  const urlPrefix = urlPrefixSelector(state)
  window.browserHistory.replace(`${urlPrefix}/booking${makeQuery(params)}`)
}

export default updateUrl
